export const updateObject = (oldObject, updatedProperties) => {
  return {
    ...oldObject,
    ...updatedProperties,
  };
};
export const checkValidity = (value, rules) => {
  let isValid = true;
  if (!rules) {
    return true;
  }

  if (rules.required) {
    isValid = value.trim() !== '' && isValid;
  }

  if (rules.minLength) {
    isValid = value.length >= rules.minLength && isValid;
  }

  if (rules.maxLength) {
    isValid = value.length <= rules.maxLength && isValid;
  }

  if (rules.isEmail) {
    const pattern = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
    isValid = pattern.test(value) && isValid;
  }

  if (rules.isNumeric) {
    const pattern = /^\d+$/;
    isValid = pattern.test(value) && isValid;
  }

  return isValid;
};
export const formatDate = (d) => {
  if (!d) return;
  const date = new Date(new Date(d).toISOString().split('T')[0]);
  const dateString =
    date.getDate().toString() +
    '.' +
    ('0' + (date.getMonth() + 1).toString()).slice(-2) +
    '.' +
    date.getFullYear().toString();
  return dateString;
};
export const getMessages = (messages) => {
  let message = '';
  if (messages)
    messages.forEach((m) => {
      message += `${m.message}, `;
    });
  return message;
};
export const getTcmMessages = (error) => {
  let message = '';
  if (error)
    error.errors.forEach((m) => {
      message += `${m} \n `;
    });
  return message;
};
export const getErrorMessages = (error) => {
  return error.response && error.response.data && error.response.data.error
    ? error.response.data.error.reduce((a, b) => a + ', ' + b)
    : '';
};
export const planStatus = {
  created: { id: 1, code: 'taslak', name: 'Taslak' },
  sentApprove: { id: 2, code: 'onayagonderildi', name: 'Onaya Gönderildi' },
  approved: { id: 3, code: 'onaylandi', name: 'Onaylandı' },
  rejected: { id: 4, code: 'reddedildi', name: 'Reddedildi' },
};
export const userRole = {
  regionalDirector: { id: 42, code: 'bolgemuduru', name: 'Bölge Müdürü' },
  promotionManager: {
    id: 43,
    code: 'tanitimmuduru',
    name: 'Tanıtım Müdürü',
  },
  director: { id: 44, code: 'direktor', name: 'Direktör' },
  sfe: { id: 46, code: 'sfe', name: 'Sfe' },
};
export const convertToNumber = (str) => {
  let convertedNumber = '';
  for (let i = 0; i < str.length; i++) {
    const element = str[i];
    if (element == '.') convertedNumber += ',';
    else if (element == ',') convertedNumber += '.';
    else convertedNumber += element;
  }
  return convertedNumber;
};
